module.exports = __webpack_public_path__ + "img/reference_02.c3c767c3.jpg";